import * as types from './mutation-types.js'
import markers from '@/services/api/markers'
import { getDeepProperty } from '@/helpers/deepObject.js'
import { getMarkerType } from '@/services/utilities/markers.js'
import api from '@/services/api'

const state = {
  createAction: false,
  markers: null
}

const actions = {
  clearMarkers ({state, commit}) {
    commit(types.CLEAR_MARKERS)
  },
  async createMarker ({state}, {path, payload}) {
    return api.post(path, payload).then(async ({data}) => {
      return data
    })
  },
  deleteMarker ({state, commit}, path) {
    return api.delete(path)
      .then(async data => {
        return data
      })
      .catch(err => {
        return err
      })
  },
  async getAudioMarkers ({commit}, path) {
    return api.get(path).then(async ({data}) => {
      return data
    })
  },
  async getEpisodeMarkers ({state, commit}, episodeId) {
    let result = await markers.getEpisodeMarkers(episodeId)

    commit(types.SET_CAN_CREATE_MARKER, result)
    commit(types.SET_MARKERS, result.collection)
  },
  async updateMarker ({state, commit}, {path, payload}) {
    let result = await api.post(path, payload).then(async ({data}) => {
      return data
    })

    return result
  }
}

const mutations = {
  [types.CLEAR_MARKERS] (state) {
    state.markers = null
  },
  [types.SET_MARKERS] (state, markers) {
    state.markers = markers
  },
  [types.SET_CAN_CREATE_MARKER] (state, marker) {
    state.createAction = getDeepProperty(marker, 'create.action')
  }
}

const getters = {
  canCreateMarkers: state => state.createAction,
  markers: state => state.markers,
  preMarkers: state => state.markers ? state.markers.filter((m) => getMarkerType(m.name) === 'pre').sort((a, b) => (a.name > b.name) ? 1 : -1) : [],
  midMarkers: state => state.markers ? state.markers.filter((m) => getMarkerType(m.name) === 'mid').sort((a, b) => (a.name > b.name) ? 1 : -1) : [],
  postMarkers: state => state.markers ? state.markers.filter((m) => getMarkerType(m.name) === 'post').sort((a, b) => (a.name > b.name) ? 1 : -1) : []
}

export default {
  state,
  actions,
  mutations,
  getters
}
